import { useState, useEffect } from 'react';

var useIsLowerResolution = function () {
    var _a = useState(false), isLowerResolution = _a[0], setIsLowerResolution = _a[1];
    if (typeof window === 'undefined') {
        return false;
    }
    var toggleMobile = function () {
        if (window.innerWidth < 592) {
            return setIsLowerResolution(true);
        }
        return setIsLowerResolution(false);
    };
    useEffect(function () {
        var timeoutId = 0;
        var resizeListener = function () {
            window.clearTimeout(timeoutId);
            timeoutId = window.setTimeout(function () { return toggleMobile(); }, 100);
        };
        window.addEventListener('resize', resizeListener);
        toggleMobile();
        return function () { return window.removeEventListener('resize', resizeListener); };
    }, []);
    return isLowerResolution;
};

export { useIsLowerResolution as default };
